<template>
    <div>
        <v-row>
            <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
                <v-text-field label="Search Here" v-model="searchQuery" class="py-0 my-0"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="py-0 my-0">
                <v-select :items="searchOptions"
                          v-model="selectedSearchOption2"
                          item-value="value"
                          item-text="text"
                          return-object
                          class="py-0 my-0"></v-select>
            </v-col>
        </v-row>
        <v-data-table :headers="headers"
                      :items="items"
                      class="elevation-1"
                      :options.sync="pagination"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :footer-props="footerProps">
            <template slot="items" slot-scope="props">
                <td v-for="(header, index) in headers" :key="index">
                    <span v-if="!header.html">{{ props.item[header.value] }}</span>
                    <span v-if="header.html" v-html="props.item[header.value]">{{props.item[header.value]}}</span>
                </td>
            </template>
            <template v-slot:item.action="{ item }">
                <slot name="actions" v-bind:item="item"></slot>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    // import { mapActions, mapState } from "vuex";
    import _ from "lodash"
    import { string } from "postcss-selector-parser";
    const API_ENDPOINT = "/api/other";
    export default {
        props: {
            payrollGroup: {
                default: 0,
                type: Number
            },
            param: {
                default: "",
                type: String
            },
            /*RLV:26Aug2022*/
            branch: {
                type: string
            },
            location: {
                type: string
            },
            group: {
                type: string
            }
        },
        data: () => ({
            // pagination: {
            //   page: 1,
            //   pageSize: 10
            // },
            // selectedSearchOption: {},
            searchQuery: "",
            searchBy: "",
            //New
            headers: [
                {
                    text: "",
                    align: "left",
                    sortable: false,
                    value: "action"
                },
                {
                    text: "Code",
                    align: "left",
                    value: "groupCode"
                },
                {
                    text: "Description",
                    align: "left",
                    value: "groupDescription"
                }
            ],
            loading: false,
            items: [],
            searchOptions: [
                {
                    text: "Code",
                    value: "groupCode"
                },
                {
                    text: "Description",
                    value: "groupDescription"
                }
            ],
            totalItems: 0,
            pagination: {
                page: 1,
                pageSize: 10
            },
            footerProps: {
                itemsPerPageOptions: [5, 10, 25, 50]
            },
            selectedSearchOption: {},
            selectedSearchOption2: {}
            //payrollGroup: 0
        }),
        methods: {
            // ...mapActions("tkGroup", [
            //   "getAll",
            //   "setPagination",
            //   "setSelectedSearchOption"
            // ]),
            search() {
                const { value } = this.selectedSearchOption2;
                this.searchBy = value;
                this.selectedSearchOption = {
                    searchBy: this.searchBy,
                    searchQuery: this.searchQuery
                };

                this.getAll();
            },
            getAll() {
                const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
                const { searchBy, searchQuery } = this.selectedSearchOption;
                this.loading = true;

                const pageNumber = page; //searchQuery == "" ? 1 : page;
                let sort = "";

                if (sortDesc.length > 0) {
                    if (sortDesc[0]) {
                        sort = "desc";
                    } else {
                        sort = "asc";
                    }
                }

                this.$axios
                    .get(
                        //RLV:26Aug2022
                        /*`${API_ENDPOINT}/tkGroup/pagination?pageNumber=${pageNumber}&pageSize=${itemsPerPage}&searchBy=${searchBy}&searchQuery=${searchQuery}&orderBy=${sortBy}&sort=${sort}&payrollGroup=${this.payrollGroup}&param=${this.param ?? ''}&branch=${this.branch}&location=${this.location}`*/
                        `${API_ENDPOINT}/tkGroup/pagination?pageNumber=${pageNumber}&pageSize=${itemsPerPage}&searchBy=${searchBy}&searchQuery=${searchQuery}&orderBy=${sortBy}&sort=${sort}&payrollGroup=${this.payrollGroup}&param=${this.param ?? ''}&branch=${this.branch}&location=${this.location}&group=${this.group}`
                    )
                    .then(({ data }) => {
                        // Set Items
                        this.items = data;
                        if (!_.isEmpty(data)) {
                            setTimeout(() => {
                                this.totalItems = data[0].totalRecords;
                            }, 1000);
                        }
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        computed: {
            // ...mapState("tkGroup", {
            //   items: state => state.items,
            //   headers: state => state.headers,
            //   footerProps: state => state.footerProps,
            //   totalItems: state => state.totalItems,
            //   searchOptions: state => state.searchOptions,
            //   loading: state => state.loading
            // }),

        },
        watch: {
            pagination: {
                handler(val) {
                    // this.setPagination(Object.assign({}, val));
                    //this.paginatio
                    this.search();
                },
                deep: true
            },
            searchQuery() {
                setTimeout(() => {
                    this.search();
                }, 500);
            },
            selectedSearchOption2() {
                this.search();
            },
        },
        mounted() {
            this.selectedSearchOption2 = this.searchOptions[0];
        }
    };
</script>
